import { render, staticRenderFns } from "./profileAvatar.vue?vue&type=template&id=33c09d48"
import script from "./profileAvatar.vue?vue&type=script&lang=js"
export * from "./profileAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports